// This is now an ES standard that is available in all modern browsers, even mobile.
export function cloneDeep<T>(obj: T): T {
    return structuredClone(obj);
}
